import { useEffect, useRef } from "react";
import "./PermissionNotice.css";

export interface PermissionNoticeProps {
  toolName: string;
  description: string;
  onGrant: () => void;
  onDeny: () => void;
}

/**
 * Solicita permiso antes de invocar una herramienta. Semántica nativa: <section> con
 * encabezado, texto explicativo y dos <button>. Sin roles ARIA redundantes: el
 * agrupamiento visual ya lo da <section aria-labelledby>, que los lectores anuncian
 * como región con nombre.
 */
export function PermissionNotice({
  toolName,
  description,
  onGrant,
  onDeny,
}: PermissionNoticeProps) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <section className="permission-notice" aria-labelledby="permission-notice-heading">
      <h3
        id="permission-notice-heading"
        className="permission-notice__heading"
        tabIndex={-1}
        ref={headingRef}
      >
        Permiso requerido: <span className="mono">{toolName}</span>
      </h3>
      <p className="permission-notice__description">{description}</p>
      <p className="permission-notice__hint">
        Esta herramienta necesita tu autorización antes de ejecutarse. Puedes denegarla sin
        efecto alguno.
      </p>
      <div className="permission-notice__actions">
        <button type="button" className="btn btn--ghost" onClick={onDeny}>
          Denegar
        </button>
        <button type="button" className="btn btn--primary" onClick={onGrant}>
          Permitir
        </button>
      </div>
    </section>
  );
}
